document.addEventListener('DOMContentLoaded', () => {
    console.log('rw session is ready to go');

  const COOKIE_NAME = "rw_session_id";
  const REF_COOKIE_NAME = "rw_ref";
  const COOKIE_DAYS = 30;

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax; Secure`;
  }

  function generateId() {
    return crypto.randomUUID()
      ? crypto.randomUUID()
      : 'xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
          const r = Math.random() * 16 | 0;
          const v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
  }

 function generateShortId() {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; 
  // no confusing 0/O/1/I

  let id = '';
  for (let i = 0; i < 8; i++) {
    id += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return id;
} 
  let sessionId = getCookie(COOKIE_NAME);
  let shortId = getCookie(REF_COOKIE_NAME);
  if (!sessionId) {
    sessionId = generateId();
    setCookie(COOKIE_NAME, sessionId, COOKIE_DAYS);
  }
  if (!shortId) {
  shortId = generateShortId();
  setCookie(REF_COOKIE_NAME, shortId, COOKIE_DAYS);
}

window.rwAnalytics = {
  sessionId,
  shortId
};

window.dispatchEvent(new Event('rw_analytics_ready'));

  function setLineItemPropertySessionId() {
    // Covers both normal theme + Zipify forms, and any quickshop forms
    const inputs = document.querySelectorAll('input[name="properties[REF]"]');

    if (!inputs.length) {
      // Not all pages have product forms; totally normal.
      return;
    }

    inputs.forEach(input => {
      if (input.value !== shortId) {
        input.value = shortId;
        console.log(`REF line-item property set on ${inputs.length} input(s)`);
      }
    });

  }

  // Set ASAP on DOM ready (sessionId exists now)
  setLineItemPropertySessionId();

  // Keep it set if theme/Zipify swaps the product form after load (variant changes, quickshop, etc.)
 let rwMoTimer = null;
let rwStopTimer = null;

const rwMo = new MutationObserver(() => {
  clearTimeout(rwMoTimer);
  rwMoTimer = setTimeout(setLineItemPropertySessionId, 50);

  clearTimeout(rwStopTimer);
  rwStopTimer = setTimeout(() => rwMo.disconnect(), 5000);
});

rwMo.observe(document.documentElement, { childList: true, subtree: true });

setTimeout(() => {
  const MAX_ATTEMPTS = 4;          // total tries (1 + retries)
  const INITIAL_BACKOFF_MS = 250;  // delay before retry #2 (then doubles)
  const JITTER_MS = 50;            // small random jitter to avoid sync collisions

  const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

  async function updateCartAttribute() {
    const resp = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin", // <-- ensure cart cookies are included
      body: JSON.stringify({
        attributes: {
          rw_session_id: sessionId,
          rw_short_session_id: shortId
        },
      }),
    });

    console.log("RAW RESPONSE:", resp.status, resp.statusText);

    // Read body safely (Shopify may return JSON, but text() avoids parse explosions)
    await resp.text();

    // Verify using /cart.js
    const cart = await fetch(`/cart.js?t=${Date.now()}`, {
      credentials: "same-origin",
    }).then((r) => r.json());

    console.log("VERIFY CART:", cart);

    if (!cart || !cart.token) {
      throw new Error("Cart exists but has no token yet");
    }

    if (cart.attributes?.rw_session_id !== sessionId) {
      throw new Error("Attribute NOT persisted");
    }

    return cart;
  }

  (async () => {
    let backoff = INITIAL_BACKOFF_MS;

    for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
      try {
        if (attempt > 1) {
          const jitter = Math.floor(Math.random() * JITTER_MS);
          await sleep(backoff + jitter);
          backoff *= 2;
        }

        const cart = await updateCartAttribute();
        console.log("SUCCESS: Attribute persisted and cart is initialized", {
          token: cart.token,
          rw_session_id: cart.attributes?.rw_session_id,
          attempts: attempt,
        });
        return;
      } catch (err) {
        console.warn(
          `Attempt ${attempt}/${MAX_ATTEMPTS} failed — ${
            err?.message || err
          }`
        );

        if (attempt === MAX_ATTEMPTS) {
          console.error("Gave up persisting rw_session_id after retries.", err);
        }
      }
    }
  })();
}, 1000);



  //Logging endpoint
  fetch("https://redwitchapi.azurewebsites.net/api/logsessiondetails?code=NU9pgGCXikSXexmJrQU0ORf45-Uwb6LPzKWy-EUfUAzMAzFujJndUw==", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    body: JSON.stringify({
      sessionId,
      url: window.location.href,
      referrer: document.referrer || null,
      userAgent: navigator.userAgent,
      ts: new Date().toISOString(),
      shortId
    })
  });
});